// extracted by mini-css-extract-plugin
export var divider = "_2g-0";
export var dividerText = "_2g-1";